"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var match = {
  FixedSessionWrapper: _cccisdLaravelAppdefs.FixedSessionWrapper
};
var DataEntry = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DataEntry, _React$Component);
  function DataEntry() {
    _classCallCheck(this, DataEntry);
    return _callSuper(this, DataEntry, arguments);
  }
  _createClass(DataEntry, [{
    key: "render",
    value: function render() {
      var _this = this;
      var tabClass = this.props.tabClass;
      var title = this.props.pageTitle === null ? "".concat((0, _capitalize2["default"])(this.props.sessionType), " Data") : this.props.pageTitle;
      var isSingle = this.props.tabs.length === 1;
      var content = '';
      if (isSingle) {
        var tab = this.props.tabs[0];
        var Component = match[tab.componentHandle];
        var sessions = [];
        tab.sessions.forEach(function (sessionHandle) {
          var fullSession = (0, _find2["default"])(AppDefs.sessions["".concat(AppDefs.sessions.sessionType, "Settings")].sessions, function (session) {
            return session.handle === sessionHandle;
          });
          sessions.push(fullSession);
        });
        content = /*#__PURE__*/_react["default"].createElement(Component, _extends({
          key: tab.handle,
          appDefData: AppDefs.sessions,
          sessionData: sessions,
          pawn: this.props.pawn
        }, tab.dataEntryProps));
      } else {
        var tabList = [];
        this.props.tabs.forEach(function (t) {
          var Component = match[t.componentHandle];
          var sessions = [];
          t.sessions.forEach(function (sessionHandle) {
            var fullSession = (0, _find2["default"])(AppDefs.sessions["".concat(AppDefs.sessions.sessionType, "Settings")].sessions, function (session) {
              return session.handle === sessionHandle;
            });
            sessions.push(fullSession);
          });
          tabList.push({
            name: t.handle,
            title: t.label,
            content: /*#__PURE__*/_react["default"].createElement(Component, _extends({
              key: t.handle,
              appDefData: AppDefs.sessions,
              sessionData: sessions,
              pawn: _this.props.pawn
            }, t.dataEntryProps))
          });
        });
        content = /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
          tabList: tabList
        });
      }
      if (this.props.isLoading) {
        content = this.props.loadingNode !== null ? this.props.loadingNode : /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.isLoading
        });
      } else if (this.props.isClientListEmpty) {
        content = /*#__PURE__*/_react["default"].createElement("div", null, this.props.clientListEmptyMessage);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.sessionType, " appdefs-data-entry ").concat(this.props.className)
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, title), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription)), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_defineProperty({}, "".concat(_cccisdStyleBible["default"][tabClass]), tabClass && !isSingle ? true : false))
      }, content));
    }
  }]);
  return DataEntry;
}(_react["default"].Component);
_defineProperty(DataEntry, "propTypes", {
  pageTitle: _propTypes["default"].string,
  pageDescription: _propTypes["default"].string,
  sessionType: _propTypes["default"].string,
  /**
   * tabs: [
   *      {
   *          handle: fdsafdas,
   *          dataEntryProps: {}
   *      },
   *      {
   *          handle: hgf,
   *          dataEntryProps: {}
   *      }
   *
   * ]
   */
  tabs: _propTypes["default"].array,
  pawn: _propTypes["default"].object,
  clientListEmptyMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  isClientListEmpty: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  loadingNode: _propTypes["default"].node,
  tabClass: _propTypes["default"].string
});
_defineProperty(DataEntry, "defaultProps", {
  pageTitle: null,
  pageDescription: '',
  sessionType: 'session',
  className: 'container',
  loadingNode: null,
  tabClass: 'impactTabs1'
});